<template>
	<TransitionRoot
		as="template"
		:show="open">
		<Dialog
			as="div"
			className="z-[99] absolute"
			:initial-focus="dialogPanelRef"
			@close="null">
			<div class="fixed top-0 right-0 p-4 sm:p-6">
				<TransitionChild
					as="template"
					enter="ease-in-out duration-300"
					enter-from="translate-x-full"
					enter-to="translate-x-0"
					leave="ease-in-out duration-300"
					leave-from="translate-x-0"
					leave-to="translate-x-full">
					<DialogPanel
						ref="dialogPanelRef"
						:class="clsx(
							className,
							sizes[size],
							'row-start-2 backdrop-blur-md w-full rounded-2xl bg-white/90 p-8 shadow-lg ring-1 ring-zinc-950/10 sm:rounded-2xl sm:p-6 dark:bg-zinc-900 dark:ring-white/10 forced-colors:outline')">
						<slot />
						<div class="ml-4 flex shrink-0 absolute top-4 right-4">
							<VButton
								plain
								@click="onClose()">
								<span class="sr-only">Close</span>
								<XMarkIcon
									class="size-5"
									aria-hidden="true" />
							</VButton>
						</div>
					</DialogPanel>
				</TransitionChild>
			</div>
		</Dialog>
	</TransitionRoot>
</template>

<script setup lang="ts">
	import VButton from "../Buttons/VButton.vue"

	import {
		clsx,
	} from "clsx"

	import {
		Dialog,
		DialogPanel,
		TransitionChild,
		TransitionRoot,
	} from "@headlessui/vue"

	import {
		ref,
		watch,
	} from "vue"

	const props = defineProps({
		className: {
			type: String,
			default: "",
		},
		onClose: {
			type: Function,
			default: () => { return },
		},
		duration: {
			type: Number,
			default: 5000,
		},
		open: {
			type: Boolean,
			default: false,
		},
		size: {
			type: String,
			default: "md",
		},
	})

	const dialogPanelRef = ref(null)

	const sizes: { [k: string]: string } = {
		xs: "sm:max-w-xs",
		sm: "sm:max-w-sm",
		md: "sm:max-w-md",
		lg: "sm:max-w-lg",
		xl: "sm:max-w-xl",
		"2xl": "sm:max-w-2xl",
		"3xl": "sm:max-w-3xl",
		"4xl": "sm:max-w-4xl",
		"5xl": "sm:max-w-5xl",
	}

	watch(() => props.open, (newValue, oldValue) => {
		if (newValue === true && oldValue == false) {
			setTimeout(() => {
				props.onClose()
			}, props.duration)
		}
	})
</script>